import {Link} from 'react-router-dom';

export default function GroupSearchLink() {
    return <Link to="/" className="inline-flex min-h-[44px] items-center justify-center rounded-sm text-center text-[10px] font-semibold uppercase tracking-[0.12em] text-[#a07dea] transition-colors hover:text-violet-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-400 sm:text-xs">
        Zur Flugsuche
    </Link>;
}
